import { useScheduleActivityLocale } from '../../activity/hooks';
import { ScheduleActivityReferencePickerPlugin } from '../../activity/types';

const LegacyScheduleActivityCustomOptionLabel: ScheduleActivityReferencePickerPlugin['CustomOptionLabel'] =
  () => {
    const { t } = useScheduleActivityLocale();

    return t('SCHEDULE');
  };

export default LegacyScheduleActivityCustomOptionLabel;
